/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { TEST_DATA, FilterData } from './test-data/collectible.assets';
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { Banner} from "./test-data/banner-data"

 
import { VApplication } from "../application";
import {GET_ASSETS} from "../pages/Collectibles/graphql/getassets.query";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { useAsset} from "../pages/Collectibles/provider";
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";

const is = require("is_js");

const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "collections.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
import {SOUND, VIDEO} from "../assets/images"
const storageService = StorageModule.getInstance();
const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");

interface IProps {
   imageServer?:any,
   store?:any;
}

export class CollectionsService { 
    name = SERVICE_NAME;
    private static instance: CollectionsService;

     private imageServer;
     private store;

    private constructor(props: IProps | any) {
        this.report();
        this.imageServer = props?.imageServer;
        this.store= props?.store
        
        console.log("this.imageserver",props?.imageServer)
    

    }

    static getInstance(props:IProps | any) {
        if (!this.instance) {
            this.instance = new CollectionsService(props);
        }
        console.log("this.",this.instance)
        return this.instance;
      
    }
    async init() {}




    async getAssets(size: number, offset: number, category: any) {
        const collectionService = CollectionsService.getInstance();
        log.info(`this.sanjay`, collectionService?.store);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter:{
                            state:["listed", "showcased", "showcased_real"],
                            store:collectionService?.store,
                            category:category
                        }
                    },
                    fetchPolicy: 'network-only'
                });
              
                console.log("ENV",collectionService.imageServer)
                if(res){
                    let _data= res?.data?.getAssets?.data;
                                      
                    let results = _data?.map((item:any)=>{
                        const imgUrl = item?.img;
                        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                        const imgBBformat = imgUrl?.split('/');
                        const ibbFormat = imgBBformat[imgBBformat.length-3]
                     
                        let _img;
                         if(ibbFormat === "i.ibb.co"){
                            // _img =`${collectionService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                            _img = item?.img
                         
                         } 
                         else {
                            //  _img = `${collectionService.imageServer}${urlFormat}/:/rs=h:500`
                            _img = item?.img
                         }

                          if(item?.type === "audio"){
                            _img = item?.thumbnail ?? SOUND
                          }
                          if(item?.type === "video"){
                            _img = item?.thumbnail ?? item?.img
                          }
                        // const imgUrl = item?.img;
                        // const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');

                        return({
                            ...item,
                            idx:item?.serialNo,
                            subtitle:item?.subtitle?.replace(/<[^>]*>?/gm, '')?.replace(/&nbsp;/g, '')?.replace(/&quot;/g,'"')?.replace(/&.*;/g,''),
                            img:_img,
                            price: item?.price?.map((item:any)=>{
                                if(item?.type==='fiat'){
                                    return({
                                        ...item,
                                        locale: 'en-US',
                                    })
                                }
                                else{
                                    return({
                                        ...item,
                                        amount:(item?.amount)?.toFixed(3)
                                    })
                                }
                            }),
                            tag: item?.tag?.toUpperCase(),
                            category: item?.tag?.toLowerCase(),
                            serialNo:`Rare #/${item?.serialNo}`,
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                            networkType:null,
                        })
                    })
                    return{
                        pagination: {
                            nextOffset: offset + res?.data?.getAssets?.pageSize,
                            totalItems: res?.data?.getAssets?.totalCount,  
                        },  
                        results
                    }
                }
            }
        } catch (err) {
            getErrorMessage(err);
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }

    async getFilterData() {
        let _filterData = FilterData;
        return _filterData;
    }

    async getBanner() {
        const  { category} = useAsset();
        let _banner = Banner[category];
        return _banner;
    }
    

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
